var _circle, _circle2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 56,
    viewBox: "0 0 66 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 28,
    r: 15.5,
    fill: "#03B09B",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7996_60142",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 12,
    width: 32,
    height: 32
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 28,
    r: 15.5,
    fill: "#03B09B",
    stroke: "#4F5B6F"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7996_60142)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 12,
    width: 32,
    height: 32,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.9624 25.0723C38.9624 28.3656 36.2927 31.0353 32.9994 31.0353C29.7062 31.0353 27.0365 28.3656 27.0365 25.0723C27.0365 21.7791 29.7062 19.1094 32.9994 19.1094C36.2927 19.1094 38.9624 21.7791 38.9624 25.0723ZM26.3764 36.3382C28.1331 34.5815 30.5149 33.5934 32.9993 33.5907C35.4836 33.5934 37.8654 34.5815 39.6221 36.3382C41.3788 38.0949 42.3669 40.4767 42.3696 42.9611V48.924C42.3696 49.15 42.2799 49.3666 42.1201 49.5264C41.9604 49.6861 41.7437 49.7759 41.5178 49.7759H38.4341C38.3279 49.7768 38.226 49.8173 38.1481 49.8895C38.0703 49.9616 38.0222 50.0603 38.0133 50.166L37.2585 59.2178C37.2406 59.4311 37.1429 59.6298 36.9851 59.7744C36.8272 59.919 36.6207 59.9989 36.4067 59.9981H29.5919C29.3778 59.9989 29.1713 59.919 29.0135 59.7744C28.8556 59.6298 28.758 59.4311 28.74 59.2178L27.9887 50.166C27.9797 50.0597 27.9311 49.9606 27.8526 49.8883C27.774 49.8161 27.6712 49.7759 27.5645 49.7759H24.4808C24.2548 49.7759 24.0382 49.6861 23.8784 49.5264C23.7187 49.3666 23.6289 49.15 23.6289 48.924V42.9611C23.6316 40.4767 24.6197 38.0949 26.3764 36.3382Z",
    fill: "#4F5B6F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 28,
    r: 15,
    stroke: "#4F5B6F",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.f33e377e643ebd4eb3a9714d0c13a96b.svg";
export { ForwardRef as ReactComponent };